/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { UntypedFormArray, UntypedFormControl, Validators } from '@angular/forms';
import { DriverTeam } from '@shared/models/driver-team';

export class TeamForm {

  '@id' = new UntypedFormControl();
  vehicle = new UntypedFormControl();
  mainDriver = new UntypedFormControl();
  additionalDrivers = new UntypedFormArray([]);

  constructor(team: DriverTeam = {vehicle: null, mainDriver: null, additionalDrivers: []}) {

    if (team['@id']) {
      this['@id'].setValue(team['@id']);
    }

    if (team.mainDriver) {
      this.mainDriver.setValue(team.mainDriver['@id']);
    }

    if (team.vehicle) {
      this.vehicle.setValue(team.vehicle['@id']);
    }

    for (const driver of team.additionalDrivers) {
      this.additionalDrivers.push(new UntypedFormControl(driver['@id'], Validators.required));
    }
  }
}
